{
  "background": {
    "background-default": "hsl(0, 0%, 98.039216%)",
    "background-subtle": "hsl(0, 0%, 96.078431%)"
  },
  "surface": {
    "surface-default": "hsl(0, 0%, 100%)",
    "surface-raised": "hsl(0, 0%, 100%)",
    "surface-sunken": "hsl(0, 0%, 96.078431%)"
  },
  "text": {
    "text-default": "hsl(204, 15.151515%, 6.470588%)",
    "text-muted": "hsl(201.818182, 7.006369%, 30.784314%)",
    "text-subtle": "hsl(198, 4.385965%, 55.294118%)",
    "text-inverse": "hsl(0, 0%, 100%)",
    "text-link": "hsl(217.2, 100%, 19.607843%)"
  },
  "border": {
    "border-default": "hsl(195, 6.060606%, 87.058824%)",
    "border-subtle": "hsl(0, 0%, 92.156863%)",
    "border-strong": "hsl(198, 4.385965%, 55.294118%)"
  },
  "action": {
    "action-default": "hsl(217.2, 100%, 19.607843%)",
    "action-hover": "hsl(222.545455, 100%, 10.784314%)",
    "action-subtle": "hsl(196, 100%, 97.058824%)"
  },
  "success": {
    "success-surface": "hsl(110, 50%, 95.294118%)",
    "success-text": "hsl(121.333333, 100%, 17.647059%)",
    "success-border": "hsl(115.081967, 35.260116%, 66.078431%)",
    "success-solid": "hsl(123.043478, 100%, 27.058824%)"
  },
  "warning": {
    "warning-surface": "hsl(20, 100%, 96.470588%)",
    "warning-text": "hsl(19.849624, 95.683453%, 27.254902%)",
    "warning-border": "hsl(18, 74.626866%, 73.72549%)",
    "warning-solid": "hsl(23.880597, 100%, 39.411765%)"
  },
  "danger": {
    "danger-surface": "hsl(3.75, 100%, 96.862745%)",
    "danger-text": "hsl(347.288136, 90.769231%, 25.490196%)",
    "danger-border": "hsl(358.636364, 67.692308%, 74.509804%)",
    "danger-solid": "hsl(346.626506, 82.178218%, 39.607843%)"
  },
  "info": {
    "info-surface": "hsl(218.571429, 46.666667%, 94.117647%)",
    "info-text": "hsl(219.74026, 60.629921%, 24.901961%)",
    "info-border": "hsl(218.181818, 35.106383%, 63.137255%)",
    "info-solid": "hsl(219.813084, 53.768844%, 39.019608%)"
  }
}
